import React from 'react';
import sponsoredCarouselTitle from './props';
import style from './style.module.scss';
import classNames from '../../../utils/classNames';

function SponsoredCarouselTitle(props: sponsoredCarouselTitle) {
  return (
      <span className={classNames('sponsored-carousel-title', style, props.classNames)}
        {...(props['data-e2e'] && {'data-e2e': props['data-e2e']})}>
        {props.text}
        {props.children}
      </span>
  );
}

export default React.memo(SponsoredCarouselTitle);
